// CMS data fetching helper for Lunde Media

export async function fetchFromCMS(endpoint) {
  try {
    const res = await fetch(endpoint, {
      headers: {
        'Accept': 'application/json',
      },
    });
    if (!res.ok) {
      throw new Error(`CMS fetch error: ${res.status}`);
    }
    return await res.json();
  } catch (err) {
    console.warn(`CMS fetch failed for ${endpoint}:`, err);
    return null;
  }
}

// Fallback seed data in case API is unreachable or during hydration
export const FALLBACK_GALLERIER = {
  bryllupper: {
    id: "2e2a53ed-19bc-4de7-9980-915a414e8d7b",
    slug: { _: "bryllupper" },
    titel: "Bryllupper",
    undertitel: "Autentiske øjeblikke, kærlighed og nærvær",
    kategori: "Bryllup",
    beskrivelse: "<p>Et bryllup handler om de øjeblikke, der ikke kan genskabes. Blikket i kirken, de små berøringer, latteren under talerne og den vilde energi på dansegulvet.</p><p>Jeg fanger jeres dag med en diskret og nærværende tilgang, så I kan nyde hvert sekund.</p>",
    billeder: [
      "/_assets/323a9475.jpg",
      "/_assets/323a9564.jpg",
      "/_assets/323a0121.jpg",
      "/_assets/323a5269.jpg",
      "/_assets/323a0549.jpg",
      "/_assets/323a0133.jpg",
      "/_assets/323a0218.jpg",
      "/_assets/323a0241.jpg",
      "/_assets/323a0400.jpg",
      "/_assets/323a0418.jpg",
      "/_assets/323a0442.jpg",
      "/_assets/323a0442-2.jpg",
      "/_assets/323a0479.jpg",
      "/_assets/323a1062.jpg",
      "/_assets/323a1337.jpg",
      "/_assets/323a2143.jpg",
      "/_assets/323a6058.jpg",
      "/_assets/323a6150.jpg",
      "/_assets/323a6213.jpg",
      "/_assets/469269727-1092454198947739-5094198924173448864-n.jpg",
      "/_assets/468821663-1092454292281063-1944310555028978061-n.jpg",
      "/_assets/472388021-1068515595291887-6236239585788099648-n.jpg",
      "/_assets/472331762-1068515591958554-2413136772439242105-n.jpg",
    ],
    cover_billede: ["/_assets/472331762-1068515591958554-2413136772439242105-n.jpg"],
  },
  cykelloeb: {
    id: "c88afa47-20f3-4e4b-a532-006851495668",
    slug: { _: "cykelloeb" },
    titel: "Cykelløb",
    undertitel: "Fart, intensitet, koncentration og fællesskab",
    kategori: "Sport",
    beskrivelse: "<p>Cykelløb er rå viljestyrke, taktik, fart og lidenskab. Fra de spændte miner i startboksen til feltets susen over asfalten og forløsningen på målstregen.</p><p>Jeg leverer billeder og video, der får tilskueren helt tæt på feltets puls og rytternes smerte og sejre.</p>",
    billeder: [
      "/_assets/467843501-1084374129755746-8742697337945456892-n.jpg",
      "/_assets/115820782-172952827564552-2790911280586450986-n.jpg",
      "/_assets/115803630-172952807564554-3070980139574409914-n.jpg",
      "/_assets/110340462-172952877564547-9114177833398868150-n.jpg",
      "/_assets/112597004-172952647564570-1166596095639646479-n.jpg",
      "/_assets/115803766-172952787564556-2756493644119945137-n.jpg",
      "/_assets/111748853-172952687564566-8112109070073407182-n.jpg",
      "/_assets/110312076-172952884231213-9180749244075845019-n.jpg",
    ],
    cover_billede: ["/_assets/115820782-172952827564552-2790911280586450986-n.jpg"],
  },
  events: {
    id: "5d21b50c-2e8d-4883-ad8b-c18d77b3f0cd",
    slug: { _: "events" },
    titel: "Events & Erhverv",
    undertitel: "Stemning, mennesker og levende dokumentation",
    kategori: "Erhverv & Kultur",
    beskrivelse: "<p>Uanset om det er en konference, en firmafest, en intim koncert eller et større kulturstævne, skaber jeg visuelt materiale med kant og sjæl.</p><p>Materiale, I kan bruge direkte i markedsføring, på sociale medier og på virksomhedens website for at tiltrække kunder og deltagere.</p>",
    billeder: [
      "/_assets/75513566-168614701331698-9032259809111210225-n.jpg",
      "/_assets/142299669-247059033487264-5481047819933199986-n.jpg",
      "/_assets/142081323-247059026820598-2713212477238493269-n.jpg",
      "/_assets/84387927-168614671331701-3333494197708786303-n.jpg",
      "/_assets/106574918-168614661331702-1972435854891904928-n.jpg",
      "/_assets/166714167-283183176541516-3142839106080478528-n.jpg",
      "/_assets/166783092-283183186541515-3612883362797497453-n.jpg",
      "/_assets/487316894-1134600408683405-7489097942827672171-n.jpg",
    ],
    cover_billede: ["/_assets/75513566-168614701331698-9032259809111210225-n.jpg"],
  },
  familiefotografering: {
    id: "3feaebe1-5aca-43b7-8735-c7570348c0aa",
    slug: { _: "familiefotografering" },
    titel: "Familiefotografering",
    undertitel: "Nærværende stunder hjemme eller i naturen",
    kategori: "Portræt & Familie",
    beskrivelse: "<p>Glem alt om stive smil og opstillede hvide baggrunde. Vi mødes på en strand, i skoven eller hjemme hos jer selv, hvor børnene føler sig trygge.</p><p>Resultatet er ægte billeder af jeres relationer, kærlighed og hverdagsmagi, som I vil værdsætte i generationer fremover.</p>",
    billeder: [
      "/_assets/img-7476.jpg",
      "/_assets/img-7466-2.jpg",
      "/_assets/img-7455-2.jpg",
      "/_assets/img-7435.jpg",
      "/_assets/img-7422-2.jpg",
      "/_assets/323a6441.jpg",
      "/_assets/323a6361.jpg",
      "/_assets/323a3654.jpg",
      "/_assets/122139316-196386581887843-7973893422891536185-n.jpg",
      "/_assets/122219496-196386571887844-6292842903634497848-n.jpg",
      "/_assets/482221143-1118484233628356-4166053169173591826-n.jpg",
      "/_assets/482211624-1118484263628353-76151960718850419-n.jpg",
      "/_assets/121001566-192835678909600-4366089546131733324-n.jpg",
      "/_assets/121062247-192835688909599-5659526319518965425-n.jpg",
      "/_assets/120995338-192835672242934-8023908548928709392-n.jpg",
    ],
    cover_billede: ["/_assets/img-7476.jpg"],
  },
};

export const FALLBACK_PAKKER = [
  {
    id: "773db48d-4ad9-4e62-b8c5-d0a2ce93989a",
    slug: { _: "vielse-og-portraetter" },
    titel: "BRONZE",
    varighed: "Bryllupspakke",
    pris: "Pris efter samtale",
    pris_foto_video: "10.900 kr.",
    pris_foto_eller_video: "6.400 kr.",
    beskrivelse: "Fanger de vigtigste og mest mindeværdige øjeblikke omkring vielsen og de klassiske bryllupsportrætter.",
    detaljer: "<ul><li>Gommens ankomst til kirken</li><li>Brudens ankomst til kirken</li><li>Vielsen</li><li>Når I sammen går ud af kirken</li><li>stemningsbilleder efter ceremonien</li><li>Portrætter af brudeparret</li></ul>",
    fremhaevet: false,
    sortering: 1,
  },
  {
    id: "38aa72ba-6233-4f4f-bb9e-1477a52ac2fb",
    slug: { _: "halvdagsdaekning" },
    titel: "SØLV",
    varighed: "Bryllupspakke",
    pris: "Pris efter samtale",
    pris_foto_video: "17.400 kr.",
    pris_foto_eller_video: "10.500 kr.",
    beskrivelse: "Udvidet dækning med vielse, stemningsbilleder, reception, kageskæring og fotografering af ringene.",
    detaljer: "<ul><li>Gommens ankomst til kirken</li><li>Bruden ankomst til kirken</li><li>Vielsen</li><li>Når I sammen går ud af kirken</li><li>Stemningsbilleder efter ceremonien</li><li>Portrætter af brudeparret</li><li>Portrætter med familie og venner</li><li>Reception/tiden før I går til bords</li><li>Bordopdækning, blomster, kageskæring m.m.</li><li>Fotografering af ringene</li></ul>",
    fremhaevet: true,
    sortering: 2,
  },
  {
    id: "9b7d6dad-ebbe-4fc3-871a-3d484be39b38",
    slug: { _: "heldagsdaekning" },
    titel: "GULD",
    varighed: "Bryllupspakke",
    pris: "Pris efter samtale",
    pris_foto_video: "18.900 kr.",
    pris_foto_eller_video: "12.500 kr.",
    beskrivelse: "Den komplette dækning af hele brylluppet fra kirkens ankomst, middag og taler til brudevals og fest til kl. 01.00.",
    detaljer: "<ul><li>Gommens ankomst til kirken</li><li>Bruden ankomst til kirken</li><li>Vielsen</li><li>Når I sammen går ud af kirken</li><li>Stemningsbilleder efter ceremonien</li><li>Portrætter af brudeparret</li><li>Portrætter med familie og venner</li><li>Reception/tiden før I går til bords</li><li>Ringene</li><li>Bordopdækning, blomster kageskæring m.m</li><li>Fællesbillede af jer med gæster</li><li>Vinen og maden</li><li>Stemningen under middagen</li><li>Taler, kindkys, traditioner m.m</li><li>Brudevalsen</li><li>Festen frem til kl.01.00</li></ul>",
    fremhaevet: false,
    sortering: 3,
  },
];

export async function getGalleriBySlug(slug) {
  // First try direct CMS slug endpoint
  const data = await fetchFromCMS(`/_api/public/by-slug/${slug}`);
  if (data && data.titel) {
    return data;
  }
  // Next try list endpoint
  const list = await fetchFromCMS('/_api/public/content/galleri');
  if (Array.isArray(list)) {
    const match = list.find((g) => {
      const s = typeof g.slug === 'string' ? g.slug : g.slug?._;
      return s === slug;
    });
    if (match) return match;
  }
  // Return fallback
  return FALLBACK_GALLERIER[slug] || null;
}

export async function getBryllupspakker() {
  const data = await fetchFromCMS('/_api/public/content/bryllupspakker');
  if (Array.isArray(data) && data.length > 0) {
    return [...data].sort((a, b) => (a.sortering || 0) - (b.sortering || 0));
  }
  return FALLBACK_PAKKER;
}

export const FALLBACK_STORYTELLING = [
  {
    id: "75084e7b-b950-4f95-9f48-e14b475407dd",
    slug: { da: "smutsten-paa-stranden" },
    titel: "Smutsten på stranden",
    undertitel: "En genskabelse af frieriet",
    kategori: "Bryllup",
    citat: "Et billede der ligger op til en fortælling, en fortælling der vækker minder, minder der vækker følelser. Dét er hvad jeg ønsker i mit virke.",
    billeder: [
      "/_assets/472331762-1068515591958554-2413136772439242105-n.jpg"
    ],
    fortaelling: "<p>Brudeparret fortalte mig under vores første samtale, at frieriet skete da de gik på stranden og kastede smutsten ud i vandet. Hun kastede en sten ud i vandet, vendte sig om og så sin kommende mand på knæ foran hende.</p><p>En smuk fortælling, jeg ønskede at genskabe da vi var på bryllupsfotografering.</p><p>At gengive frieriet når de var i deres bryllupstøj ville ikke virke, så jeg poserede dem på denne måde.</p><p>Et billede der ligger op til en fortælling, en fortælling der vækker minder, minder der vækker følelser.</p><p>Dét er hvad jeg ønsker i mit virke.</p><p><strong>Fortællingen, minderne og følelserne.</strong></p>",
    sortering: 1
  }
];

export async function getStorytelling() {
  // Try v2 sorted endpoint first
  const v2Data = await fetchFromCMS('/_api/public/v2/content/storytelling?sort=sortering&order=asc');
  if (v2Data && Array.isArray(v2Data.items) && v2Data.items.length > 0) {
    return v2Data.items;
  }
  // Try plain list endpoint
  const list = await fetchFromCMS('/_api/public/content/storytelling');
  if (Array.isArray(list) && list.length > 0) {
    return [...list].sort((a, b) => (a.sortering || 0) - (b.sortering || 0));
  }
  return FALLBACK_STORYTELLING;
}

export const FALLBACK_ANBEFALINGER = [
  {
    id: "majken",
    navn: "Majken",
    begivenhed: "Bryllupsfotografering",
    kategori: "bryllup",
    stjerner: 5,
    fremhaevet: true,
    sortering: 1,
    tekst: "<p>Jeg vil til hver en tid anbefale at bruge Michael, hvis man har en begivenhed der skal foreviges. Vi fik taget de bedste billeder i forbindelse med vores bryllup. Vi havde enkelte ideer til nogle billeder, og de blev lige som vi havde håbet på (og måske endda også lidt bedre).</p><p>Michael fik skudt de helt rigtige billeder af de små og store øjeblikke der var i kirken og havde de mest kreative ideer til de “obligatoriske” brudepar billeder bagefter.</p><p>Det eneste jeg fortryder nu, er at vi ikke havde ham med hele dagen.</p>",
  },
  {
    id: "henrik",
    navn: "Henrik",
    begivenhed: "Familiefotografering & Erhverv",
    kategori: "familie",
    stjerner: 5,
    fremhaevet: true,
    sortering: 2,
    tekst: "<p>Har været så heldig at jeg har fået taget nogle virkelige gode billeder af min søn og jeg samt til mit firma.</p><p>Michael er virkeligt god til at fange de naturlige øjeblikke, og man føler sig virkelig i gode hænder. Michael er et meget positivt og roligt menneske, som gør at min søn føler sig glad og tryg, og det har givet nogle virkelige gode billeder.</p>",
  },
  {
    id: "heidi-marie",
    navn: "Heidi Marie",
    begivenhed: "Konfirmationsfotografering",
    kategori: "familie",
    stjerner: 5,
    fremhaevet: true,
    sortering: 3,
    tekst: "<p>Vi har benyttet os af Lunde Media til begge vores pigers konfirmation og kan varmt anbefale ham!</p><p>Michael er på pletten udenfor kirken og fanger detaljer og øjeblikke, som man ikke selv når at få med på sådan en dag. Michael møder én med godt humør og en god energi og er især god til at fange de særlige øjeblikke, så billederne bliver naturlige og meget personlige.</p>",
  },
  {
    id: "morten-bonde",
    navn: "Morten Bonde",
    begivenhed: "Boglancering & Erhvervsfotografering",
    kategori: "erhverv",
    stjerner: 5,
    fremhaevet: true,
    sortering: 4,
    tekst: "<p>Da jeg skulle lancere min bog <em>Dømt blind - hva' så?</em> i det gamle bibliotek på Koldinghus, havde jeg bestilt Michael Lunde fra Lunde Media til at følge mig på dagen.</p><p>Michael opererede som en usynlig Ninja blandt gæster og mig, uden det på nogen måde var en gene. Jeg fik taget nogle fantastiske billeder – uden jeg overhovedet opdagede det – og hvor er jeg glad for, at jeg besluttede at hyre Michael til opgaven. Ud over at være en superdygtig fotograf, er han nemlig også en rar fyr. Topkarakter til Lunde Media!</p>",
  },
  {
    id: "ironhorse-derby",
    navn: "Ironhorse Derby",
    begivenhed: "Cykelløb & Event",
    kategori: "events",
    stjerner: 5,
    fremhaevet: true,
    sortering: 5,
    tekst: "<p>Kæmpe anbefaling til Lunde Media! Lunde Media var med til Ironhorse derby 2026 og leverede nogle virkelig fede billeder. Lunde har formået at fange lige præcis det, vi gerne vil vise med Ironhorse – stemningen, fællesskabet, intensiteten og alle de små øjeblikke undervejs.</p><p>Det er billeder, hvor man virkelig kan mærke dagen, og som giver os mulighed for at genopleve nogle af de øjeblikke, vi selv havde travlt med at få til at hænge sammen. Tusind tak for at forevige Ironhorse på den måde, vi håbede på. Vi er virkelig glade for resultatet!</p>",
  },
];

export async function getAnbefalinger() {
  const data = await fetchFromCMS('/_api/public/content/anbefalinger');
  if (Array.isArray(data) && data.length > 0) {
    return [...data].sort((a, b) => (a.sortering || 0) - (b.sortering || 0));
  }
  return FALLBACK_ANBEFALINGER;
}
